import { ICalendarDay } from '../types';

function getWeekDayNumber(year: number, month: number, day: number) {
  const weekDayIndexSunday = new Date(year, month, day).getDay(); // 0 - Вс; 6 - Сб.
  const weekDayIndex = weekDayIndexSunday === 0 ? 6 : weekDayIndexSunday - 1; // 0 - Пн; 6 - Вс.
  return weekDayIndex;
}

function getCalendarDays(year: number, month: number): (ICalendarDay | null)[][] {
  const dayCount = new Date(year, month + 1, 0).getDate();
  const weeks: (ICalendarDay | null)[][] = [];

  let week: (ICalendarDay | null)[] = [];

  for (let dayNumber = 1; dayNumber <= dayCount; dayNumber++) {
    const weekDayIndex = getWeekDayNumber(year, month, dayNumber);

    if (dayNumber === 1) {
      for (let i = 0; i < weekDayIndex; i++) {
        week.push(null);
      }
    }

    if (week.length === 7) {
      weeks.push(week);
      week = [];
    }

    week.push({
      year: year,
      month: month,
      day: dayNumber,
      dayOfWeek: weekDayIndex,
    });
  }

  if (week.length > 0) {
    while (week.length < 7) {
      week.push(null);
    }

    weeks.push(week);
  }

  return weeks;
}

export default getCalendarDays;
